import { Gem } from "lucide-react";
//import { useState } from "react";
import { isMobileDevice } from "../../../services/utils";
import { Dialog, DialogContent } from "../ui/dialog";
import { Drawer, DrawerContent } from "../ui/drawer";
// import UpgradePremiumModal from "./UpgradePremiumModal";
// import UpgradeToPremiumCTA from "../../../components/UpgradeToPremiumCta";

const UpgradePremium = ({ onUpgradeClick }) => {
  // const [isOpen, setIsOpen] = useState(false);
  // const upgradeJob = () => {
  //   onUpgradeClick(true);
  // };
  // const onModalClose = () => {
  //   setIsOpen(false);
  // };
  const isMobile = isMobileDevice();
  const Modal = !isMobile ? Dialog : Drawer;
  const ModalContent = !isMobile ? DialogContent : DrawerContent;
  return (
    <>
      <div className="flex justify-between items-center bg-[#DBEAFE33] px-[14px] py-[10px] rounded-t-[8px] text-sm font-medium">
        <div className="flex w-1/2">Upgrade to access premium filters</div>
        <div
          className="flex items-center text-blue-600 font-bold cursor-pointer"
          onClick={onUpgradeClick}
        >
          <Gem className="h-4 mr-1" />
          Upgrade
        </div>
      </div>
      {/* <UpgradeToPremiumCTA
        onClickHandler={upgradeJob}
        page="dashboard"
        item={{ job_id: 254734, status: "LIVE", jobPlan: "BASIC" }}
        hideSubTag={true}
      /> */}
      {/* <Modal open={isOpen} onOpenChange={onModalClose}>
        <ModalContent>
          <UpgradePremiumModal />
        </ModalContent>
      </Modal> */}
    </>
  );
};
export default UpgradePremium;
